import './winmock/style';
import FormStructure from './winmock/form_structure';

export default FormStructure;